import Vue from 'vue'
import lazySizes from 'lazysizes'

Vue.use(lazySizes)
